// AD-2692: on an application or acceptance form, each parent needs their own email address and mobile number. The
// template marks the answers with the keys below; Parent 2's answers only count when Parent 2's questions are shown.
export const SAME_PARENT_CONTACT_MESSAGE =
    'Each parent needs their own email address and mobile number. Please change the details for Parent 2, then click on Submit again.';

const normaliseEmail = value => String(value ?? '').trim().toLowerCase();
const normaliseMobile = value => String(value ?? '').replace(/\D/g, '').replace(/^44/, '0');

const answerFor = (schema, data, key, isShown) => {
    const field = (schema ?? []).find(f => f.key === key);
    if (!field || (isShown && !isShown(field))) return '';
    return data?.[field.id];
};

// The Parent 2 question to take the person to, or null when the parents' details are different.
export const sameParentContactField = (schema, data, isShown) => {
    const email1 = normaliseEmail(answerFor(schema, data, 'parent1Email', isShown));
    const email2 = normaliseEmail(answerFor(schema, data, 'parent2Email', isShown));
    const mobile1 = normaliseMobile(answerFor(schema, data, 'parent1Mobile', isShown));
    const mobile2 = normaliseMobile(answerFor(schema, data, 'parent2Mobile', isShown));
    const key = email2 && email1 === email2 ? 'parent2Email' : mobile2 && mobile1 === mobile2 ? 'parent2Mobile' : null;
    return key ? (schema ?? []).find(f => f.key === key) : null;
};
